import {fromJS, Map} from 'immutable';
import {combineReducers} from 'redux-immutable';

import paginatorReducer from '../../paginator/reducer';
import treeReducer from '../tree/reducer';
import Examinations from './component';
import mainReducer from './reducer';


export const initialState = {};

const _reducer = combineReducers({
    main: mainReducer,
    paginator: paginatorReducer,
    gradesTreeFilter: treeReducer,
    typesTreeFilter: treeReducer,
    stepsTreeFilter: treeReducer,
    onlineTreeFilter: treeReducer,
    registeredTreeFilter: treeReducer,
    restrictedTreeFilter: treeReducer,
    yearsTreeFilter: treeReducer,
    regionsTree: treeReducer,
    citiesTree: treeReducer,
    schoolsTree: treeReducer,
    selected: q => q || new Map(),
});
export const reducer = (state, action) => {
    if (!state.get('paginator')) {
        const id = state.get('elementId') || window.uuidv4();
        state = fromJS({
            main: {elementId: id},
        });
    }
    state = _reducer(state, action);
    state = state.set('selected', state.get('paginator').get('selected'));
    return state;
};

export const component = Examinations;
